import styled from 'styled-components';
const StyledOperationsHubOnboardingContainer = styled.div.withConfig({
  displayName: "StyledOperationsHubOnboardingContainer",
  componentId: "sc-1vlq89o-0"
})(["width:100%;height:0;pointer-events:none;display:none;@media only screen and (min-width:768px){display:block;}"]);
export default StyledOperationsHubOnboardingContainer;